/**
 * RTK Query service for the session init composite endpoint.
 *
 * GET /api/v1/{b2b|b2c}/session/init returns:
 *   { dropdowns, application_status, user }
 *
 * This replaces 20+ individual dropdown / status queries that previously
 * fired on every page mount.  Data is cached for the entire session
 * (keepUnusedDataFor: Infinity) and only refreshed on login or manual
 * invalidation.
 */
import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders, CheckAuth } from 'auth/auth';
import { baseQueryWithReauth } from './baseQuery';

const isUuidLike = (value) => {
  if (!value) return false;
  return /^[0-9a-fA-F-]{36}$/.test(String(value));
};

const resolvePortalPrefix = () => {
  const cachedUser = CheckAuth() || {};
  const role = String(cachedUser.role || cachedUser.originalRole || '').toLowerCase();
  const userId = cachedUser.user_id;

  if (role === 'consumer' || isUuidLike(userId)) {
    return 'b2c';
  }
  return 'b2b';
};

export const sessionInitAPI = createApi({
  reducerPath: 'sessionInitAPI',
  tagTypes: ['sessionInit'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getSessionInit: builder.query({
      query: () => ({
        url: `${resolvePortalPrefix()}/session/init`,
        method: 'GET',
        headers: getHeaders(),
      }),
      keepUnusedDataFor: Infinity, // cache for entire session
      providesTags: ['sessionInit'],
    }),
  }),
});

export const { useGetSessionInitQuery } = sessionInitAPI;
